export default __webpack_public_path__ + "static/media/apple.af998401.svg";